import { render } from "./former-employee.vue?vue&type=template&id=038f3d38&scoped=true&ts=true"
import script from "./former-employee.vue?vue&type=script&lang=ts"
export * from "./former-employee.vue?vue&type=script&lang=ts"

import "./former-employee.vue?vue&type=style&index=0&id=038f3d38&scoped=true&lang=stylus"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-038f3d38"]])

export default __exports__